import { render } from "./settings.vue?vue&type=template&id=583e1cf6"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=583e1cf6&lang=scss"
script.render = render

export default script